module.exports = __webpack_public_path__ + "img/vehicle-options-black-infiniti.f9f061b1.png";